import { render, staticRenderFns } from "./BoardCardCancelContent.vue?vue&type=template&id=1c51fdd8&"
import script from "./BoardCardCancelContent.vue?vue&type=script&lang=js&"
export * from "./BoardCardCancelContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports